import Vue from 'vue'
import apiService from '../../services/ApiService'

export default {
  async getPayments(context, filters) {
    try {
      const { data: result } = await apiService.getPayments(filters)
      if (result && result.success) {
        context.commit('setPayments', result.data)
      } else {
        if (result.error && result.error.message) throw Error(result.error.message)
        else throw Error(this.$i18n.t('errors.something_wrong'))
      }
    } catch (error) {
      if (error && error.message) Vue.toasted.show(error.message)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/merchants.js